<template>
  <div class="vip-regular">
    <img style="width: 80%;" src="../../../assets/img/invest/vip.png" alt="   ">
  </div>
</template>

<script>
import * as ProductApi from "@/api/product";
import { Tab, Tabs, Toast, Dialog } from "vant";

export default {
  name: "TianVipRegular",

  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },

  data() {
    return {
      activeName: "全部产品",
      tabbars: [
        { name: "全部产品", tag: "all", pageNo: 0, product_list: [] },
        { name: "3个月内", tag: "three", pageNo: 0, product_list: [] },
        { name: "3-6个月", tag: "six", pageNo: 0, product_list: [] },
        { name: "6个月以上", tag: "twelve", pageNo: 0, product_list: [] }
      ]
    };
  },

  created() {
    this.onChangeTab(0);
  },

  methods: {
    onChangeTab(index) {
      let investDuration = this.tabbars[index].tag;
      let pageNo = this.tabbars[index].pageNo + 1;
      let pageSize = 10;
      let the = this;

      ProductApi.list({
        investDuration,
        pageNo,
        pageSize
      }).then(data => {
        the.tabbars[index].product_list = data.list;
      }).catch(e => {
        Toast(e.msg || e.message);
      });
    },

    onToDetail(productId) {
      this.$router.push({ path: "/detail", query: { productId } });
    }
  }
};
</script>

<style lang="less" scoped>
.vip-regular {
}
</style>

